export default __webpack_public_path__ + "static/media/024-pirate.b468291a.png";